import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const pushChannel = defineChannel({
  id: 'push',
  icon: 'mobile',
  name: 'Push notification',
  shortName: 'push',
  noun: 'push notification',
  events: [
    'attempted',
    'sent',
    'delivered',
    'deferred',
    'failed',
    'bounced',
    'opened',
    'clicked',
    'drafted',
    'undeliverable',
  ],
} as const satisfies ChannelDefinition);
